import React, { useEffect, useState } from "react";
import PageWrapper from "../components/PageWrapper";
import Colors from '../styles/Colors.json';
import { useSiteContext } from "../SiteContext";
import { getCommentsForPayPeriod } from "../api/comments";
import { Comment } from "../interfaces/CommentInterface";
import './EmployeeView.css';

const CommentsPage: React.FC = () => {
    const { payPeriodID, setLoading } = useSiteContext();
    const [comments, setComments] = useState<Comment[]>([]);

    // Fetch comments when pay period changes
    useEffect(() => {
        const fetchComments = async () => {
            if (!payPeriodID || payPeriodID === 0) {
                setComments([]);
                return;
            }

            setLoading(true);
            try {
                const data = await getCommentsForPayPeriod(payPeriodID);
                setComments(data || []);
            } catch (error) {
                console.error("Error fetching comments:", error);
                setComments([]);
            } finally {
                setLoading(false);
            }
        };

        fetchComments();
    }, [payPeriodID, setLoading]);

    // Format employee name
    const formatEmployeeName = (name: { first: string; middle: string; last: string }) => {
        return `${name.first} ${name.last}`;
    };

    return (
        <PageWrapper title="Timesheet Comments" backgroundColor={Colors.White} weekSelector={true}>
            {payPeriodID === 0 ? (
                <p>Please select a pay period to view timesheet comments.</p>
            ) : comments.length === 0 ? (
                <p>No timesheet comments found for the selected pay period.</p>
            ) : (
                <div className="employee-view-table">
                    <table>
                        <thead>
                            <tr className="employee-view-table-row-blue">
                                <th style={{ cursor: 'default' }}>Employee Name</th>
                                <th style={{ cursor: 'default' }}>Employee ID</th>
                                <th style={{ cursor: 'default' }}>Supervisor Name</th>
                                <th style={{ cursor: 'default' }}>Comment</th>
                            </tr>
                        </thead>
                        <tbody>
                            {comments.map((comment, index) => (
                                <tr 
                                    key={`${comment.timesheetID}-${comment.timesheetQuestionID}`}
                                    className={index % 2 === 1 ? "employee-view-table-row-blue" : "employee-view-table-row-white"}
                                >
                                    <td>{formatEmployeeName(comment.employeeName)}</td>
                                    <td>{comment.altEmployeeID}</td>
                                    <td>{comment.supervisor ? formatEmployeeName(comment.supervisor.name) : '-'}</td>
                                    <td>{comment.comment || '-'}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </PageWrapper>
    );
};

export default CommentsPage;
